<template>
    <div class="w-full text-white py-8 bg-gradient-to-t from-navigation to-primaire">
        <div class="container max-w-7xl mx-auto flex flex-wrap justify-between px-2">
            <div
                class="w-full pt-1 mb-5 sm:w-1/2 md:w-1/4 lg:w-1/6 bg-gradient-to-l from-white to-transparent rounded-lg">
                <router-link to="/"><img src="/src/assets/images/logo.svg" alt="logo"
                        class="h-48 mx-auto object-contain" title="Animaux de la seconde chance">
                </router-link>

            </div>
            <!-- Colonne 1 -->
            <div class="w-1/2 md:w-1/4 lg:w-1/6 px-4 mb-4">
                <h2 class="text-xl font-bold mb-4">À propos</h2>
                <ul>
                    <li><router-link to="notre-mission" class="block hover:text-gray-300">Notre mission</router-link>
                    </li>
                    <li><router-link to="faire-un-don" class="block hover:text-gray-300">Faire un don</router-link></li>
                    <li><router-link to="adoption" class="block hover:text-gray-300">Info adoption</router-link></li>
                </ul>
            </div>

            <!-- Colonne 2 -->
            <div class="w-1/2 md:w-1/4 lg:w-1/6 px-4 mb-4">
                <h2 class="text-xl font-bold mb-4">Services</h2>
                <ul>
                    <li><router-link to="famille-accueil" class="block hover:text-gray-300">Être famille
                            d'accueil</router-link></li>
                    <li><router-link to="animaux-perdus" class="block hover:text-gray-300">Animaux perdus</router-link>
                    </li>
                </ul>
            </div>

            <!-- Colonne 3 -->
            <div class="w-1/2 md:w-1/4 lg:w-1/6 px-4 mb-4">
                <h2 class="text-xl font-bold mb-4">Adoption</h2>
                <ul>
                    <li><router-link to="chatons-0-5-mois" class="block hover:text-gray-300">Chatons 0-5
                            mois</router-link></li>
                    <li><router-link to="chatons-6-12-mois" class="block hover:text-gray-300">Chatons 6-12 mois</router-link>
                    </li>
                    <li><router-link to="chats-femelles" class="block hover:text-gray-300">Femelles 1 an et
                            +</router-link></li>
                    <li><router-link to="chats-males" class="block hover:text-gray-300">Mâles 1 an et +</router-link>
                    </li>
                    <li><router-link to="nos-adoptes" class="block hover:text-gray-300">Chats adoptés</router-link></li>
                </ul>
            </div>

            <!-- Colonne 4 -->
            <div class="w-1/2 md:w-1/4 lg:w-1/6 px-4 mb-4">
                <h2 class="text-xl font-bold mb-4">Contact</h2>
                <ul>
                    <li><router-link to="/nous-joindre" class="block hover:text-gray-300">Contactez-nous</router-link>
                    </li>
                    <li class="flex align-items"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                            fill="currentColor" class="bi bi-facebook mt-1" viewBox="0 0 16 16">
                            <path
                                d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                        </svg><a href="https://www.facebook.com/animauxsecondechance" target="_blank"
                            rel="noopener noreferrer" class="block hover:text-gray-300 ml-2">Facebook</a></li>
                </ul>
            </div>
        </div>
        <hr class="w-4/5 mt-2 mx-auto">

        <div class="text-center my-5">
            <router-link to="protection-des-renseignements-personnels" class="hover:underline">Politique de
                confidentialité</router-link>
        </div>

        <!-- Bas de page -->
        <div class="text-center mt-4 px-10">
            <p>Tous droits réservés &copy; Animaux de la Seconde Chance. 2025-2026<br>Réalisation:  <a
                    href="https://cfweb.ca/" class="underline hover:no-underline hover:text-gray-300"
                    title="CFWeb">CFWeb</a></p>
        </div>
    </div>

</template>

<script>

</script>

<style scoped>
.span-bg {
    background-color: white;
    padding-right: 0.5rem;
    border-top-left-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
    font-weight: bold;

}
</style>